export default "__VITE_ASSET__D25F5EUm__"